export default __webpack_public_path__ + "static/media/pilot.fb9beaae.png";